// import AllRoutes from "./AllRoute/AllRoutes";
// import Footer from "./components/Footer";
// import Header from "./components/Header";
// import "./App.css";
// import { ToastContainer } from "react-toastify";
// import ScrollToTop from "./components/ScrollTop";
// import ScrollToTopButton from "./components/scrollTop/ScollTop";

// function App() {
//   return (
//     <>
//     <ScrollToTop/>
//       <Header />
//       <AllRoutes />
//       <Footer />
//       <ToastContainer position="bottom-right" autoClose={5000} />
//       <ScrollToTopButton />
//     </>
//   );
// }

// export default App;


import { useEffect } from "react";
import { ToastContainer, toast } from "react-toastify";

import AllRoutes from "./AllRoute/AllRoutes";
import Footer from "./components/Footer";
import Header from "./components/Header";
import ScrollToTop from "./components/ScrollTop";
import ScrollToTopButton from "./components/scrollTop/ScollTop";

import "./App.css";
import "react-toastify/dist/ReactToastify.css";

function App() {
  useEffect(() => {
    let isLoggedOut = false;

    const logout = () => {
      if (isLoggedOut) return;

      isLoggedOut = true;

      sessionStorage.clear();

      toast.info("Your session has expired. Please login again.", {
        autoClose: 1500,
      });

      setTimeout(() => {
        window.location.replace("/");
      }, 1500);
    };

    const checkTokenExpiry = () => {
      const token = sessionStorage.getItem("authToken");

      if (!token) return;

      try {
        const payload = JSON.parse(atob(token.split(".")[1]));

        if (!payload.exp) {
          logout();
          return;
        }

        const currentTime = Math.floor(Date.now() / 1000);

        if (currentTime >= payload.exp) {
          logout();
        }
      } catch (error) {
        console.error("Invalid Token:", error);
        logout();
      }
    };

    // Initial check
    checkTokenExpiry();

    // Check every second
    const interval = setInterval(checkTokenExpiry, 1000);

    return () => clearInterval(interval);
  }, []);

  return (
    <>
      <ScrollToTop />

      <Header />

      <AllRoutes />

      <Footer />

      <ToastContainer
        position="bottom-right"
        autoClose={5000}
        newestOnTop
        pauseOnHover
        closeOnClick
      />

      <ScrollToTopButton />
    </>
  );
}

export default App;